import React from 'react';
import { Link } from 'react-router-dom';
import { Popover } from '@myua/kit';
import { createSearchParamsURL } from 'src/creativeHub/modules/search/model';
import { Tag } from '../../../../../general/model';
import { Tag2 } from '@myua/icons/dist/linear16';
import { FileManagerRow } from '../../model';

export const TagsCell: React.FC<{ cellData: Tag[]; rowData: FileManagerRow }> = (props) => {
  if (!props.cellData || props.cellData.length === 0) {
    return null;
  }
  return (
    // Содержимое интерактивное (ссылки на поиск по тегу), поэтому Popover, а не
    // Tooltip. Курсор может заходить в поповер — у antd при hover-триггере это
    // поведение по умолчанию, отдельного пропа (как semantic `hoverable`) не нужно.
    // Автоподжатие к границам окна тоже включено по умолчанию (`autoAdjustOverflow`).
    <Popover
      placement="left"
      content={
        <div className="ch-file-manager__tags">
          {props.cellData.map((tag) => (
            <Link
              to={createSearchParamsURL(
                null,
                true,
                [tag.id],
                props.rowData.searchParamsContext?.scope ?? null,
              )}
              key={tag.id}
              className="ch-file-manager__tag"
              title={`Search by tag: ${tag.name}`}
            >
              <span className="ch-file-manager__tag-text">{tag.name}</span>
            </Link>
          ))}
        </div>
      }
    >
      <div className="ch-file-manager__tags-button">
        <Tag2 />
      </div>
    </Popover>
  );
};
